import ReactQueryClientProvider from './ReactQueryClientProvider'
import queryClient from './queryClient'

export default ReactQueryClientProvider

export {
  queryClient,
}
